// Neutral notice shown on /login when the API ends the session (token expired, revoked, or the
// account deactivated). The wording never says which of those happened.
export const SESSION_ENDED_QUERY = '?reason=session-ended';
export const SESSION_ENDED_MESSAGE = 'Your session has ended. Please sign in again.';

/** The notice text for a /login URL's query string, or null when there is none to show. */
export const sessionEndedNotice = (search) => {
  try {
    return new URLSearchParams(search || '').get('reason') === 'session-ended' ? SESSION_ENDED_MESSAGE : null;
  } catch {
    return null;
  }
};
